<template>
  <div class="p-grid powerbi-page">
    <div class="p-col-12 powerbi-page__column">
      <div class="card card-w-title powerbi-page__card">
        <div class="manager-title" v-text="title"></div>
        <DropdownScrollable :loading="loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="items" :total="total" @keyup="emitEvent" @offset="changeOffset"/>
        <div v-if="powerbi_show" class="powerbi-page__frame-wrap" :key="componentKey">
            <iframe
                class="powerbi-page__frame"
                title="Power BI Report"
                :src="url_powerbi"
                frameborder="0"
                allowfullscreen>
            </iframe>
        </div>
        <div v-else class="powerbi-page__frame-wrap">
          <span>Không tìm thấy dữ liệu</span>
        </div>
    </div>
    </div>
  </div>
</template>
<script>
import DropdownScrollable from '@/components/DropdownScrollable.vue';
import ApiRepository from "@/core/ApiRepository";
export default {
  components: {
    DropdownScrollable
  },
  data() {
    return {
      filters : {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: 'Power BI',
      componentKey: 0,
      page_transaction:null,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      dataDelete :{},
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      company: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      popupWarning: false,
      powerbi_show: false,
      url_powerbi : "",
      //https://app.powerbi.com/view?r=eyJrIjoiMDg5MzBkODItZjY4ZC00ODkzLThiNmEtNDVkOTM5OWI5M2Q3IiwidCI6ImRmYTcyNWJkLWFkYWQtNDc4ZS1iZDEzLWI1OGI2NmNmNGNhYiIsImMiOjEwfQ%3D%3D&pageName=e31089f5c397da425f81
    }
  },
  async created() {
    await this.initParams();
    if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
      await this.getListCompany()
    }
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
        this.company = {id: this.$route.query.company_id};
        setTimeout(() => {
          const query = Object.assign({}, this.$route.query);
          delete query.company_id;
          this.$router.replace({ query });
        }, 100);
      }
    }
    this.getData();
  },
  watch: {
    '$route': 'initParams',
    'company'() {
      // this.componentKey++;
      if ((this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.company_id = this.company.id;
        this.getData();
      }
    }
  },
  async mounted () {
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
      }
      if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
        this.company_id = this.$route.query.company_id;
        this.getData();
      }
    }
  },
  methods: {
    emitEvent(keyword) {
      this.$delete(this.filters, 'name');
      if (keyword) {
        this.filters.name = keyword;
      }
      this.getListCompany();
    },
    changeOffset(value) {
      this.offset = value;
      this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.filters, limit: 20, offset: this.offset}, {headers}).then((res) => {
            if (this.offset > 0) {
              this.items.push(...res.data.data.company);
            } else {
              this.items = res.data.data.company;
            }
            this.total = res.data.data.total;
            this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    async initParams() {
      this.$store.commit('setLoading', true);
      if (this.$store.getters.type !== this.$constants.TYPE_USER.SUPPER_ADMIN) {
        this.company = {id : this.$store.getters?.company_id}
        this.company_id = this.$store.getters?.company_id;
      }
    },
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async getData() {
      this.$commonFuction.is_loading(true);
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token && this.company_id){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var {data} = await ApiRepository.post("/_api/company/detail_normal", {company_id: this.company_id}, {headers});
        var value = data.data;
        // this.models = value;
        if(value.url_powerbi){
          this.powerbi_show = true
          this.url_powerbi = value.url_powerbi ?? ''
        }else{
          this.powerbi_show = false
          this.url_powerbi = ''
        }
      }else{
        this.powerbi_show = false
        this.url_powerbi = ''
      }
      this.componentKey++;
      this.$commonFuction.is_loading(false);
    },
  },
}
</script>
<style lang="css">
.powerbi-page {
  min-height: calc(95vh - 16px);
}

.powerbi-page__column {
  display: flex;
}

.powerbi-page__card {
  width: 100%;
  min-height: calc(95vh - 16px);
  display: flex;
  flex-direction: column;
}

.powerbi-page__frame-wrap {
  flex: 1;
  min-height: calc(95vh - 180px);
}

.powerbi-page__frame {
  width: 100%;
  height: 100%;
  min-height: calc(95vh - 180px);
  border: 0;
  display: block;
}

.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.p-button-warning-o .p-button-label-o{
  color: #e95d57;
}
.p-button-warning .pi-times{
  color: #e95d57;
}

@media (max-width: 768px) {
  .powerbi-page,
  .powerbi-page__card {
    min-height: calc(100vh - 90px);
  }

  .powerbi-page__frame-wrap,
  .powerbi-page__frame {
    min-height: calc(100vh - 220px);
  }
}
</style>
